export default __webpack_public_path__ + "static/media/2164.b30652a4.png";